import type {
  AuditEntry,
  ModerationItem,
  VerificationTask,
} from '../types/operations'

export const platformMetrics = [
  { label: 'Registered students', value: '128,402', delta: '+6.4% this month' },
  { label: 'Weekly active users', value: '74,918', delta: '+3.1%' },
  { label: 'Listed beds', value: '18,264', delta: '+812 this month' },
  { label: 'Housing applications', value: '9,144', delta: '+18.2%' },
  { label: 'Verified employers', value: '512', delta: '+24' },
  { label: 'Institutions onboarded', value: '31', delta: '+2' },
]

export const supplyDemand = [
  { city: 'Lagos', demand: 7080, supply: 3120, listings: 1840 },
  { city: 'Ile-Ife', demand: 2410, supply: 1960, listings: 720 },
  { city: 'Zaria', demand: 1980, supply: 2240, listings: 640 },
  { city: 'Enugu', demand: 1620, supply: 980, listings: 410 },
  { city: 'Ibadan', demand: 2980, supply: 1740, listings: 880 },
]

export const verificationQueue: VerificationTask[] = [
  {
    id: 'ver-1',
    subject: 'Yaba Loft — shared 3 bedroom',
    type: 'Property document',
    submittedBy: 'Lagos Rooms Agency',
    submitted: '11 Aug 2026',
    status: 'Awaiting review',
  },
  {
    id: 'ver-2',
    subject: 'Iwaya Property Managers',
    type: 'Owner identity',
    submittedBy: 'Iwaya Property Managers',
    submitted: '10 Aug 2026',
    status: 'Awaiting review',
  },
  {
    id: 'ver-3',
    subject: 'Unlisted recruiter — campus ambassador role',
    type: 'Employer',
    submittedBy: 'brandreach.ng',
    submitted: '9 Aug 2026',
    status: 'Escalated',
  },
  {
    id: 'ver-4',
    subject: 'Federal University Oye-Ekiti',
    type: 'Institution',
    submittedBy: 'ICT Directorate',
    submitted: '7 Aug 2026',
    status: 'Awaiting review',
  },
  {
    id: 'ver-5',
    subject: 'Fadeyi Living Ltd',
    type: 'Property document',
    submittedBy: 'Fadeyi Living Ltd',
    submitted: '5 Aug 2026',
    status: 'Approved',
  },
]

export const moderationQueue: ModerationItem[] = [
  {
    id: 'mod-1',
    subject: 'Bariga Twin Rooms',
    surface: 'Listing',
    reason: 'Duplicate listing — same photos as two other adverts',
    reports: 7,
    raised: '2 hours ago',
    severity: 'High',
  },
  {
    id: 'mod-2',
    subject: 'Campus Brand Ambassador — unlisted recruiter',
    surface: 'Job',
    reason: 'Requests an upfront payment from applicants',
    reports: 12,
    raised: '5 hours ago',
    severity: 'High',
  },
  {
    id: 'mod-3',
    subject: 'Roommate profile — anonymous user',
    surface: 'Roommate profile',
    reason: 'Harassing messages reported by two students',
    reports: 2,
    raised: 'Yesterday',
    severity: 'High',
  },
  {
    id: 'mod-4',
    subject: 'Review on Akoka Gardens Hostel',
    surface: 'Review',
    reason: 'Possible defamatory claim about the caretaker',
    reports: 1,
    raised: '2 days ago',
    severity: 'Medium',
  },
  {
    id: 'mod-5',
    subject: 'Send-forth mixer event',
    surface: 'Event',
    reason: 'Ticket price differs from advertised price',
    reports: 3,
    raised: '3 days ago',
    severity: 'Low',
  },
]

export const auditLog: AuditEntry[] = [
  {
    id: 'aud-1',
    actor: 'K. Balogun',
    actorRole: 'Trust and safety',
    action: 'Suspended listing',
    target: 'Bariga Twin Rooms',
    time: 'Today 09:42',
    scope: 'Moderation',
  },
  {
    id: 'aud-2',
    actor: 'System',
    actorRole: 'Fraud detection',
    action: 'Flagged duplicate media fingerprint',
    target: '3 listings in Bariga',
    time: 'Today 08:15',
    scope: 'Moderation',
  },
  {
    id: 'aud-3',
    actor: 'A. Nwosu',
    actorRole: 'Verification analyst',
    action: 'Approved property documents',
    target: 'Fadeyi Living Ltd',
    time: 'Yesterday 16:20',
    scope: 'Verification',
  },
  {
    id: 'aud-4',
    actor: 'O. Ade',
    actorRole: 'Platform administrator',
    action: 'Granted institution admin role',
    target: 'ABU Samaru — Registry',
    time: 'Yesterday 11:03',
    scope: 'Operations',
  },
  {
    id: 'aud-5',
    actor: 'M. Danjuma',
    actorRole: 'Compliance',
    action: 'Accessed confidential report record',
    target: 'Incident SF-20369',
    time: '11 Aug 14:47',
    scope: 'Sensitive data',
  },
  {
    id: 'aud-6',
    actor: 'System',
    actorRole: 'Havazon Notify',
    action: 'Dispatched emergency alert',
    target: 'UNILAG Akoka — 31,964 recipients',
    time: '11 Aug 09:30',
    scope: 'Operations',
  },
]

export const reportedAccounts = [
  { id: 'rep-1', account: 'brandreach.ng', role: 'Employer', reports: 12, state: 'Restricted' },
  { id: 'rep-2', account: 'Emeka A.', role: 'Agent', reports: 9, state: 'Under review' },
  { id: 'rep-3', account: 'anon-user-4402', role: 'Student', reports: 2, state: 'Warned' },
]
